import React from 'react';
import S from "./Card.module.css";

const BasicImgCard = ({ imgPath, title, wrapClass }) => {

  const BasicImgCardWrap = {
    fontSize: '20px',
    width: '217px',
    height: '376px',
    marginBottom: '60px',
    backgroundColor: '#FFF',
    
  };
  const BasicImgDiv = {
    width: '217px',
    height: '306px',
    backgroundColor: '#F8F9FA',
    textAlign: 'center',
    border: '1px solid #D9D9D9'
  };
  const BasicImgTitleDiv = {
    margin:'20px',
    color: '#000',
    fontSize: '19px',
    fontWeight: '400',
    lineHeight: '25px',
    textAlign: 'center',
    whiteSpace: 'pre-line',
  };
  const BasicImgTag = {
    width: '100%',
  };
  return (
    <div style={BasicImgCardWrap} className={S[wrapClass]}>
      <div style={BasicImgDiv}>
        <img style={BasicImgTag} src={imgPath} />
      </div>
      <div style={BasicImgTitleDiv}>
        {title}
      </div>
    </div>
  );
}

export default BasicImgCard;
